import {
    CTAAnchor,
    CTAGeneric,
    CTALink,
    CTALiveShopping,
    CTAMissing,
    CTAToken,
    CTAVto,
    TOKEN_TYPE,
    Tokens,
} from "@hermes/api-model-common";

import { FILTERS_QUERY_PARAM } from "@hermes/hermes-web-fragments-filters-utils";

export function isCTALink(token: CTAToken | undefined): token is CTALink {
    return (
        token !== undefined &&
        (token.tokenType === TOKEN_TYPE.ctaStory ||
            token.tokenType === TOKEN_TYPE.ctaCategory)
    );
}

export function isCTALinkOrMissing(
    token: CTAToken | undefined,
): token is CTALink | CTAMissing | CTALiveShopping {
    return (
        token !== undefined &&
        (token.tokenType === TOKEN_TYPE.ctaStory ||
            token.tokenType === TOKEN_TYPE.ctaCategory ||
            token.tokenType === TOKEN_TYPE.ctaMissing ||
            token.tokenType === TOKEN_TYPE.ctaLiveShopping)
    );
}

export function isCTAMissing(token: CTAToken | undefined): token is CTAMissing {
    return token !== undefined && token.tokenType === TOKEN_TYPE.ctaMissing;
}

export function isCTAVto(token: CTAToken | undefined): token is CTAVto {
    return token !== undefined && token.tokenType === TOKEN_TYPE.ctaVto;
}

export function isCTAShadeFinder(
    token: CTAToken | undefined,
): token is CTAGeneric {
    return token !== undefined && token.tokenType === TOKEN_TYPE.ctaShadeFinder;
}

export function isCTALiveShopping(
    token: CTAToken | undefined,
): token is CTALiveShopping {
    return (
        token !== undefined && token.tokenType === TOKEN_TYPE.ctaLiveShopping
    );
}

export function isCtaAnchor(token: CTAToken | undefined): token is CTAAnchor {
    return token !== undefined && token.tokenType === TOKEN_TYPE.ctaAnchor;
}

export function ctaButtonList(
    tokens: Tokens | undefined,
): Array<CTAVto | CTAGeneric | CTALiveShopping> {
    return (
        tokens?.filter(
            (token) =>
                isCTAVto(token) ||
                isCTAShadeFinder(token) ||
                isCTALiveShopping(token),
        ) ?? []
    );
}

export function resolveCTALinkOrCTAAnchor(
    token: CTAToken | undefined,
): CTALink | CTAAnchor | undefined {
    if (isCTALink(token) || isCtaAnchor(token)) {
        return token;
    }
    return undefined;
}

export function resolveCTALink(
    token: CTAToken | undefined,
): CTALink | undefined {
    if (isCTALink(token)) {
        return token;
    }
    return undefined;
}

export function isFilteredCategory(path: string) {
    return (
        path.includes(`?${FILTERS_QUERY_PARAM}=`) ||
        path.includes(`&${FILTERS_QUERY_PARAM}=`)
    );
}
